const okPopupStore = {
    namespaced: true,
    state:{
        showPopup: false,
        msg: ""
    },
    mutations: {
        updateMsg(state, msg){
            state.msg = msg;
        },
        updateShowPopup(state, value){
            state.showPopup = value
        }
    }
};
export default okPopupStore;